import { render, staticRenderFns } from "./IconAccordion.vue?vue&type=template&id=6a346c12&scoped=true&"
import script from "./IconAccordion.vue?vue&type=script&lang=js&"
export * from "./IconAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a346c12",
  null
  
)

export default component.exports